import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { get, size, forEach, includes, filter, isEmpty } from "lodash";

import { fetchPost } from "../../api/fetch";
import { driveInOut, trainInOut, walkInOut } from "../../constants/reducers";
import {
  driveInOutFields,
  walkInOutFields,
} from "../../resources/SiteLogFields";
import {
  extractDriveInOutInfo,
  extractWalkInOutInfo,
  extractTrainInOutInfo,
  fetchLog,
  getDacLov,
  addChildEventGroups,
  addPictures,
  fetchOverridenByUsers,
  getReferenceSurvey,
} from "../../utils/eventGroups";
import {
  extractValuesFromData,
  setFiltersFromValues,
  mergeFiltersWithValues,
  setRequestFilters,
} from "../../utils/filters";
import { getUser } from "../../utils/users";
import { addTabHistory } from "./tabHistory";
import {
  dataStorePut,
  getGlobalPreferencesFromState,
  updateSiteDataStore,
} from "../../utils/userDataStore";

import {
  RESET_TABS,
  ADD_TAB,
  SAVE_TAB_DATA,
  REMOVE_TAB,
  CHANGE_TAB_ZONE,
  REQUEST_LOGS_TAB,
  RECEIVE_LOGS_TAB,
  RECEIVE_LOGS_TAB_OLD,
  FAILED_LOGS_TAB,
  SORT_LOGS_TAB,
  FILTER_LOGS_TAB,
  ADD_LATEST_LOG_TAB,
  RESET_TAB_LOGS,
  UPDATE_LOG_TAB,
  UPDATE_LOG_DATA,
  UPDATE_LOG_SELECTED_RAILCAR_ID,
  UPDATE_LOG_SELECTED_UNIT_ID,
  SET_LOGS_PAGE,
  SET_LOGS_ROWS_PER_PAGE,
  SET_DETECTION,
  SET_MAIN_NOTES,
  SET_COLLAPSED,
  UPDATE_FILTERED_LOGS,
  UPDATE_FILTERS,
} from "../../constants/actionTypes";
import {
  GLOBAL_PREFERENCES,
  DYNAMIC_TAB,
} from "../../constants/siteEntranceExit";
import { human } from "../../constants/common";
import { eventGroupsData } from "../../constants/eventGroups";
import { LOG_EVENT_GROUP_TYPES } from "../../constants/logEventGroupTypes";

/**************************************************************
 * Tabs Management
 ***************************************************************/

export const resetTabs = (name) => ({
  type: RESET_TABS,
  name,
});

export const addNewTab = (name, index, newTab = {}, removeTabs) => ({
  type: ADD_TAB,
  name,
  index,
  newTab,
  removeTabs,
});

export const addTab = (
  name,
  index,
  newTab = {},
  goTo,
  updateDataStore = true,
  fromSection = "main"
) => {
  return async (dispatch, getState) => {
    let currentTabs = getState().siteEntranceExit[name].tabs;
    // For dynamic tabs check if the tab already exists to prevent duplicate
    if (newTab.type === DYNAMIC_TAB) {
      let match = currentTabs
        .map((t, i) => ({ ...t, index: i }))
        .filter((t) => t.eventGroupId === newTab.eventGroupId);
      if (match.length > 0) {
        //if (goTo) dispatch(selectTab(name, match[0].index, fromSection));
      } else {
        let remainingSpace = window.innerWidth - 200 * size(currentTabs);
        let removeTab;
        if (remainingSpace < 300) {
          forEach(currentTabs, (t, i) => {
            if (get(t, ["type"]) === DYNAMIC_TAB && !removeTab) {
              removeTab = i;
            }
          });
        }
        try {
          console.log('addTab fetching event_groups');
          let eventGroup = await fetchPost("new/event_groups", {
            filter: {
              ids: [get(newTab, ["eventGroupId"])],
            },
            data: [
              "id",
              "type",
              {
                name: "events",
                data: [
                  "id",
                  "active",
                  "created_on",
                  "created_by",
                  "type",
                  "profile",
                  "zone",
                ],
              },
            ],
          });
          eventGroup = get(eventGroup, ["items", 0]);
          if (includes(get(LOG_EVENT_GROUP_TYPES, name), get(eventGroup, ["type", "id"]))) {
            let zone = get(
              filter(get(eventGroup, ["events"]), (e) => !isEmpty(e.zone)),
              [0, "zone"]
            );
            dispatch(
              addNewTab(
                name,
                index,
                { ...newTab, zone },
                removeTab ? [removeTab] : null
              )
            );
            if (updateDataStore) {
              await updateSiteDataStore(name, getState());
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    } else {
      dispatch(addNewTab(name, index, newTab));
    }
  };
};

export const removeTab = (name, id) => {
  return async (dispatch, getState) => {
    let tabs = get(getState(), ["siteEntranceExit", name, "tabs"]);
    let tab = get(
      filter(tabs, (t) => t.id === id),
      [0]
    );
    let index;
    forEach(tabs, (t, i) => {
      if (t.id === id) {
        index = i;
      }
    });
    if (tab && tab.type === DYNAMIC_TAB) {
      dispatch({
        type: REMOVE_TAB,
        name,
        index,
      });
      dispatch(addTabHistory(name, tab));
      updateSiteDataStore(name, getState());
    }
  };
};

export const changeTabZone = (name, index, zone) => ({
  type: CHANGE_TAB_ZONE,
  name,
  index,
  zone,
});

export const removeOldestDynamicTab = (name) => {
  return (dispatch, getState) => {
    let oldestDynTabIndex;
    getState().siteEntranceExit[name].tabs.forEach((tab, index) => {
      if (tab.type === DYNAMIC_TAB && !oldestDynTabIndex) {
        oldestDynTabIndex = index;
      }
    });
    dispatch(removeTab(name, oldestDynTabIndex));
  };
};

export const fetchTabData = (name, tab) => {
  return async (dispatch, getState) => {
    try {
      // console.log('tabs action fetchTabData', tab);
      let language = get(getState(), ["user", "language"]);
      let res = await fetchLog(name, { ids: [tab.eventGroupId] }, language);
      let index;
      getState().siteEntranceExit[name].tabs.forEach((t, i) => {
        if (t.eventGroupId === tab.eventGroupId) {
          index = i;
        }
      });
      if (index || index === 0) {
        let tabWithData = { ...tab };
        tabWithData.type = DYNAMIC_TAB;
        tabWithData.data = res;
        tabWithData.zone = {
          id: res.main.zoneId,
          name: res.main.zone,
        };
        dispatch({
          type: SAVE_TAB_DATA,
          name,
          tab: tabWithData,
          index,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
};

/**************************************************************
 * Logs Management
 ***************************************************************/

const requestLogsTab = (name, index) => ({
  type: REQUEST_LOGS_TAB,
  name,
  index,
});

const receiveLogsTab = (
  name,
  index,
  logs,
  filteredLogs,
  filters,
  total,
  offset,
  sort,
  pageNb
) => ({
  type: RECEIVE_LOGS_TAB,
  name,
  index,
  logs,
  filteredLogs,
  filters,
  total,
  offset,
  sort,
  pageNb,
});

const failedLogsTab = (name, index) => ({
  type: FAILED_LOGS_TAB,
  name,
  index,
  payload: "Failed to load logs from database.",
});

const sortLogs = (name, data, index) => ({
  type: SORT_LOGS_TAB,
  name,
  index,
  payload: data,
});

const filterLogs = (name, data, index) => ({
  type: FILTER_LOGS_TAB,
  name,
  index,
  payload: data,
});

export const fetchLogsTab = (name, index, zoneIds, types, params) => {
  return async (dispatch, getState) => {
    let tab = getState().siteEntranceExit[name].tabs[index];

    if (params.force || !tab.logs.logs || tab.logs.isFetching) {
      dispatch(requestLogsTab(name, index));

      let body = {
        filter: {
          events: { zones: zoneIds },
          types,
        },
        pagination: {
          offset: params.offset || 0,
        },
        data: eventGroupsData,
      };
      if (params.limit) {
        body.pagination.limit = params.limit;
      }
      try {
        // console.log('tabs action fetchLogsTab fetching event_groups');
        let lov = await getDacLov(name);
        let response = await fetchPost("new/event_groups", body);
        let eventGroups = [];
        let values = {};
        let total = response.total;
        let childEventGroups = await fetchChildEventGroups(
          name, 
          response.items.map((item) => item.id)
        );

        for (let i = 0; i < response.items.length; i++) {
          let group;
          if (name === driveInOut) {
            group = extractDriveInOutInfo(response.items[i], getState, lov);
          } else if (name === walkInOut) {
            group = extractWalkInOutInfo(response.items[i], getState, lov);
          } else if (name === trainInOut) {
            group = extractTrainInOutInfo(response.items[i], getState, lov)
          }
          group = addChildEventGroups(
            name,
            group,
            childEventGroups.filter((item) => item.parent.id === group.id),
            lov,
            get(getState(), ["user", "language"])
          );
          if (get(group, [human, "verification", 0, "surveyIdToFetch"])) {
            group[human].verification[0] = await getReferenceSurvey(
              get(group, [human, "verification", 0, "surveyIdToFetch"]),
              lov,
              get(getState(), ["user", "language"]),
              get(group, [human, "verification", 0, "instruction"]),
              get(group, [human, "verification", 0, "instructionColor"])
            );
          }
          group = addPictures(name, group);
          eventGroups.push(group);
          values = await extractValuesFromData(values, group);
        }

        // Set filters
        let filters = setFiltersFromValues(name, values);
        dispatch({
          type: RECEIVE_LOGS_TAB_OLD,
          name,
          index,
          logs: eventGroups,
          filteredLogs: applyFilter(
            eventGroups,
            "main",
            "active",
            filters["main"]["active"]
          ),
          filters,
          total,
          offset: response.items.length,
          sort: {
            field: "main",
            subField: "ref",
            orderDesc: true,
          },
        });
      } catch (e) {
        console.log(e);
        dispatch(failedLogsTab(name, index));
      }
    }
  };
};

// If no filters are provided, already existing filters are used
export const fetchLogsTabNew = (name, index, filters = null, page = null) => {
  return async (dispatch, getState) => {
    let tab = get(getState(), ["siteEntranceExit", name, "tabs", index]);

    if (page === null || !parseInt(page)) page = get(tab, ["logs", "pageNb"]);
    if (!filters) filters = get(tab, ["logs", "filters"]);

    if (!get(tab, ["logs", "isFetching"])) {
      dispatch(requestLogsTab(name, index));

      let body = {
        filter2: {
          log: {
            zones: {
              operation: "==",
              values: tab.zoneIds,
            },
            activity_types: {
              operation: "==",
              values: tab.logTypes,
            },
          },
        },
        pagination: {
          offset: (get(tab, ["logs", "rowsPerPage"]) || 10) * page,
          limit: get(tab, ["logs", "rowsPerPage"]) || 10,
        },
        data: eventGroupsData,
      };

      body = setRequestFilters(body, filters);

      try {
        // console.log('tabs action fetchLogTabsNew fetching event_groups', filters);
        let lov = await getDacLov(name);
        let response = await fetchPost("new/event_groups", body);
        let eventGroups = [];
        let values = {};
        let total = response.total;
        let childEventGroups = await fetchChildEventGroups(
          name, 
          response.items.map((item) => item.id)
        );

        for (let i = 0; i < response.items.length; i++) {
          let group;
          if (name === driveInOut) {
            group = extractDriveInOutInfo(response.items[i], getState, lov);
          } else if (name === walkInOut) {
            group = extractWalkInOutInfo(response.items[i], getState, lov);
          } else if (name === trainInOut) {
            group = extractTrainInOutInfo(response.items[i], getState, lov)
          }

          group = addChildEventGroups(
            name,
            group,
            childEventGroups.filter((item) => item.parent.id === group.id),
            lov,
            get(getState(), ["user", "language"])
          );
          if (get(group, [human, "verification", 0, "surveyIdToFetch"])) {
            group[human].verification[0] = await getReferenceSurvey(
              get(group, [human, "verification", 0, "surveyIdToFetch"]),
              lov,
              get(getState(), ["user", "language"]),
              get(group, [human, "verification", 0, "instruction"]),
              get(group, [human, "verification", 0, "instructionColor"])
            );
          }
          group = addPictures(name, group);
          eventGroups.push(group);
          values = await extractValuesFromData(values, group);
        }

        filters = mergeFiltersWithValues(filters, values);
        //let filters = setFiltersFromValues(name, values);
        dispatch(
          receiveLogsTab(
            name,
            index,
            eventGroups,
            applyFilter(
              eventGroups,
              "main",
              "active",
              get(filters, ["main", "active"]) || true
            ),
            filters,
            total,
            response.items.length,
            {},
            page
          )
        );
      } catch (e) {
        console.log(e);
        dispatch(failedLogsTab(name, index));
      }
    }
  };
};

export const fetchChildEventGroups = async (section, parent_ids) => {
  if (parent_ids && parent_ids.length > 0) {
    try {
      // console.log(`tab action fetchChildEventGroups`, parent_ids);
      let childEventGroups = [];
      let totalChild = 0;
      let res;
      // Request Thermal event groups in a separate query without the images
      const LOG_CHILD_EVENT_GROUP_TYPES = {
        walkInOut: [[1, 10, 11, 12, 14], [13]],
        driveInOut: [[1, 10, 11, 12, 14], [13]],
        trainInOut: []
      }
      // Note the following is a hack.  The entire 1st load and then update
      // of the tab related data need to be normalized and refactored
      // instead of having these hacks.
      // TODO: Redesign and remove the following hack
      if (parent_ids.length === 1) {
        LOG_CHILD_EVENT_GROUP_TYPES.trainInOut = [[11, 12, 23]]
      }
      // console.log('tab action fetchChildEventGroups - LOG_CHILD_EVENT_GROUP_TYPES', LOG_CHILD_EVENT_GROUP_TYPES);

      const childEventGroupsIds = get(LOG_CHILD_EVENT_GROUP_TYPES, section);
      for (let i = 0; i < childEventGroupsIds.length; i++) {
        let offset = 0;
        totalChild++;
        let data = section === trainInOut 
          ? eventGroupsData
          : [
              "id",
              "active",
              "created_on",
              "created_by",
              "type",
              "profile",
              "event_count",
              "parent",
              "images",
              "description",
              "risk_level",
              "status",
              "start",
              "end",
              "luke_index",
              {
                name: "events",
                data: [
                  "id",
                  "active",
                  "created_on",
                  "created_by",
                  "type",
                  "profile",
                  "zone",
                  "event_count",
                  "attributes",
                  "notes",
                  "luke_index",
                  "device",
                  "parent_event_id",
                  "group",
                  "event_version",
                  "reference_event_id",
                  "verification",
                ],
              },
            ];
        while (childEventGroups.length < totalChild) {
          if (i === 0 && section !== trainInOut) {
            data[data.length - 1].data.push("images");
          }
          let actualFilter;
          if (childEventGroupsIds[i].length === 0) 
            actualFilter = {
              parent_ids
            };
          else 
            actualFilter = {
              parent_ids,
              types: childEventGroupsIds[i],
            };
          res = await fetchPost("new/event_groups", {
            filter: actualFilter,
            pagination: {
              limit: 30,
              offset,
            },
            data,
          });
          childEventGroups.push(...res.items);
          totalChild = res.total;
          offset = childEventGroups.length;
        }
      }
      return childEventGroups;
    } catch (e) {
      console.log(e);
    }
  }
  return [];
};

export const sort = (name, index, field, subField) => {
  return (dispatch, getState) => {
    let logs = getState().siteEntranceExit[name].tabs[index].logs.filteredLogs;
    let sort = getState().siteEntranceExit[name].tabs[index].logs.sort;

    let orderDesc = false;
    if (sort.subField === subField && sort.field === field) {
      orderDesc = !sort.orderDesc;
    }

    logs = sortFunction(logs, field, subField, orderDesc);

    dispatch(
      sortLogs(
        name,
        {
          filteredLogs: logs,
          sort: {
            field,
            subField,
            orderDesc,
          },
        },
        index
      )
    );
  };
};

const sortFunction = (data, field, subField, orderDesc) => {
  data.sort((a, b) => {
    if (typeof a[field][subField] === "string") {
      return orderDesc
        ? a[field][subField].localeCompare(b[field][subField]) * -1
        : a[field][subField].localeCompare(b[field][subField]);
    } else {
      if (a[field][subField] < b[field][subField] && orderDesc) {
        return 1;
      } else {
        return -1;
      }
    }
  });
  return data;
};

export const addLogFilter = (name, index, field, subField, filter) => {
  return (dispatch, getState) => {
    let filteredLogs = getState().siteEntranceExit[name].tabs[index].logs.logs;
    let filters = getState().siteEntranceExit[name].tabs[index].logs.filters;

    let fields =
      name === driveInOut ? driveInOutFields.fields : walkInOutFields.fields;
    let subFields =
      name === driveInOut
        ? driveInOutFields.subFields
        : walkInOutFields.subFields;
    let verified =
      name === driveInOut
        ? driveInOutFields.verified
        : walkInOutFields.verified;
    fields.forEach((f) => {
      subFields[f.subFieldsId].forEach((sf) => {
        if (sf.name !== subField || f.name !== field) {
          filteredLogs = applyFilter(
            filteredLogs,
            f.name,
            sf.name,
            filters[f.name][sf.name]
          );
        }
      });
      verified.forEach((verif) => {
        if (verif.name !== subField || f.name !== field) {
          filteredLogs = applyFilter(
            filteredLogs,
            f.name,
            verif.name,
            filters[f.name][verif.name]
          );
        }
      });
    });
    filteredLogs = applyFilter(filteredLogs, field, subField, filter);

    /*let sort = getState().siteEntranceExit[name].tabs[index].logs.sort;
    filteredLogs = sortFunction(
      filteredLogs,
      sort.field,
      sort.subField,
      sort.orderDesc
    );*/

    dispatch(
      filterLogs(name, { filteredLogs, field, subField, filter }, index)
    );
  };
};

export const updateFilters = (name, index, filters) => ({
  type: UPDATE_FILTERS,
  name,
  index,
  filters,
});

// Reapply filters
export const updateFilteredLogs = (name) => {
  return (dispatch, getState) => {
    let index = 0;
    let filters = getState().siteEntranceExit[name].tabs[index].logs.filters;
    let filteredLogs = getState().siteEntranceExit[name].tabs[index].logs.logs;
    Object.keys(filters).forEach((k) => {
      Object.keys(filters[k]).forEach((h) => {
        filteredLogs = applyFilter(filteredLogs, k, h, filters[k][h]);
      });
    });
    dispatch({ name, type: UPDATE_FILTERED_LOGS, index, filteredLogs });
  };
};

const applyFilter = (filteredData, field, subField, filter) => {
  if (!filter) {
    return filteredData;
  }
  if (filter.type === "select" && filter.filter) {
    if (subField === "verified") {
      filteredData = filteredData.filter(
        (row) =>
          filter.filter.includes("all") ||
          (filter.filter.includes("blank") &&
            (!row[field][subField] ||
              (!row[field][subField][0] &&
                !row[field][subField][1] &&
                !row[field][subField][2] &&
                !row[field][subField][3]))) ||
          (row[field][subField] &&
            ((filter.filter.includes(I18n.get("site_fuelLevel")) &&
              row[field][subField][0]) ||
              (filter.filter.includes(I18n.get("site_odometer")) &&
                row[field][subField][1]) ||
              (filter.filter.includes(I18n.get("site_seal")) &&
                row[field][subField][2]) ||
              (filter.filter.includes(I18n.get("site_temperatures")) &&
                row[field][subField][3])))
      );
    } else {
      filteredData = filteredData.filter(
        (row) =>
          filter.filter.includes("all") ||
          (filter.filter.includes("blank") && !row[field][subField]) ||
          filter.filter.includes(row[field][subField])
      );
    }
  } else if (
    filter.type === "date" &&
    filter &&
    filter.startDate &&
    filter.endDate &&
    filter.startDate !== filter.endDate
  ) {
    filteredData = filteredData.filter(
      (row) =>
        new Date(row[field][subField]).getTime() < filter.endDate &&
        new Date(row[field][subField]).getTime() > filter.startDate
    );
  } else if (filter.type === "search" && filter.filter) {
    filteredData = filteredData.filter(
      (row) =>
        filter.filter === "" ||
        (row[field][subField] &&
          row[field][subField]
            .toString()
            .toLowerCase()
            .includes(filter.filter.toLowerCase()))
    );
  }
  return filteredData;
};

const addLatestLogTab = (name, index, log) => ({
  type: ADD_LATEST_LOG_TAB,
  name,
  index,
  payload: log,
});

export const getLatestLog = (name, index) => {
  return async (dispatch, getState) => {
    let tab = get(getState(), ["siteEntranceExit", name, "tabs", index]);

    if (get(tab, ["zone", "id"])) {
      let body = {
        filter2: {
          log: {
            zones: {
              operation: "==",
              values: [tab.zone.id],
            },
            activity_types: {
              operation: "==",
              values: get(LOG_EVENT_GROUP_TYPES, name)
            },
          },
        },
        pagination: {
          offset: 0,
          limit: 3,
        },
        data: eventGroupsData,
      };
      //body = setRequestFilters(body, get(tab, ["logs", "filters"]));

      setTimeout(async () => {
        try {
          let lov = await getDacLov(name);
          let response = await fetchPost("new/event_groups", body);
          let eventGroups = [];
          let values = {};
          let childEventGroups = await fetchChildEventGroups(
            name, 
            response.items.map((item) => item.id)
          );

          for (let i = 0; i < response.items.length; i++) {
            let data = response.items[i];
            let group;
            if (name === driveInOut) {
              group = extractDriveInOutInfo(data, getState, lov);
            } else if (name === walkInOut) {
              group = extractWalkInOutInfo(data, getState, lov);
            } else if (name === trainInOut) {
              group = extractTrainInOutInfo(data, getState, lov)
            }
            group = addChildEventGroups(
              name,
              group,
              childEventGroups.filter((item) => item.parent.id === group.id),
              lov,
              get(getState(), ["user", "language"])
            );
            if (get(group, [human, "verification", 0, "surveyIdToFetch"])) {
              group[human].verification[0] = await getReferenceSurvey(
                get(group, [human, "verification", 0, "surveyIdToFetch"]),
                lov,
                get(getState(), ["user", "language"]),
                get(group, [human, "verification", 0, "instruction"]),
                get(group, [human, "verification", 0, "instructionColor"])
              );
            }
            group = addPictures(name, group);
            eventGroups.push(group);
          }
          // Fetch processed by users
          if (!values.main) {
            values.main = {};
          }
          values.main.processedBy = [];
          for (var i = 0; i < eventGroups.length; i++) {
            if (eventGroups[i].main.processedBy) {
              let response = await getUser(eventGroups[i].main.processedBy);
              let processedBy =
                response.profile.firstname + " " + response.profile.lastname;
              if (!values.main.processedBy.includes(processedBy)) {
                values.main.processedBy.push(processedBy);
              }
              eventGroups[i].main.processedBy = processedBy;
            }
          }
          // Fetch overriden by users
          await fetchOverridenByUsers(eventGroups);

          dispatch(addLatestLogTab(name, index, eventGroups));

          // Apply filters on new entries for general log
          let filters = get(tab, ["logs", "filters"]);
          forEach(filters, (v, k) => {
            forEach(v, (value, key) => {
              eventGroups = applyFilter(eventGroups, k, key, value);
            });
          });
          dispatch(addLatestLogTab(name, 0, eventGroups));
        } catch (e) {
          console.log(e);
          dispatch(failedLogsTab(name, index));
        }
      }, 2000);
    }
  };
};

const updateLog = (name, index, replaceIndex, eventGroup, filters) => ({
  type: UPDATE_LOG_TAB,
  name,
  index,
  replaceIndex,
  eventGroup,
  filters,
});

const updateData = (name, index, eventGroup) => ({
  type: UPDATE_LOG_DATA,
  name,
  index,
  eventGroup,
});

export const updateOneLog = (
  name,
  dynamicTabIndex,
  openFromIndex,
  eventGroupId
) => {
  return async (dispatch, getState) => {
    let body = {
      filter: {
        ids: [eventGroupId],
      },
      data: eventGroupsData,
    };
    try {
      // console.log(`tabs action updateOneLog`, name, dynamicTabIndex, openFromIndex, eventGroupId);
      let lov = await getDacLov(name);
      let response = await fetchPost("new/event_groups", body);
      let eventGroups = [];
      let values = {};
      let childEventGroups = await fetchChildEventGroups(
        name, 
        response.items.map((item) => item.id)
      );

      for (let i = 0; i < response.items.length; i++) {
        let group;
        if (name === driveInOut) {
          group = extractDriveInOutInfo(response.items[i], getState, lov);
        } else if (name === walkInOut) {
          group = extractWalkInOutInfo(response.items[i], getState, lov);
        } else if (name === trainInOut) {
          group = extractTrainInOutInfo(response.items[i], getState, lov)
        }
        group = addChildEventGroups(
          name,
          group,
          childEventGroups.filter(
            (item) => get(item, ["parent", "id"]) === group.id
          ),
          get(getState(), ["user", "language"])
        );
        if (get(group, [human, "verification", 0, "surveyIdToFetch"])) {
          group[human].verification[0] = await getReferenceSurvey(
            get(group, [human, "verification", 0, "surveyIdToFetch"]),
            lov,
            get(getState(), ["user", "language"]),
            get(group, [human, "verification", 0, "instruction"]),
            get(group, [human, "verification", 0, "instructionColor"])
          );
        }
        group = addPictures(name, group);
        eventGroups.push(group);
        values = await extractValuesFromData(values, group);
      }
      // console.log(eventGroups);
      // Fetch overriden by users
      await fetchOverridenByUsers(eventGroups);

      // Update the log entry in the LOGS_TAB
      let logs = getState().siteEntranceExit[name].tabs[0].logs.logs;
      let replaceIndex;
      forEach(logs, (l, i) => {
        if (l.id === eventGroups[0].id) {
          replaceIndex = i;
        }
      });
      let filters = mergeFiltersWithValues(
        getState().siteEntranceExit[name].tabs[0].logs.filters,
        values
      );
      dispatch(updateLog(name, 0, replaceIndex, eventGroups[0], filters));

      // Get index of the current entry
      if (openFromIndex) {
        logs = getState().siteEntranceExit[name].tabs[openFromIndex].logs.logs;
        logs.forEach((l, i) => {
          if (l.id === eventGroups[0].id) {
            replaceIndex = i;
          }
        });
        // Update the log entry in the STATIC_TAB concerned
        dispatch(updateLog(name, openFromIndex, replaceIndex, eventGroups[0]));
      }

      // Update the DYNAMIC_TAB data
      if (dynamicTabIndex) {
        dispatch(updateData(name, dynamicTabIndex, eventGroups[0]));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const updateSelectedRailcarId = (name, dynamicTabIndex, selectedRailcarId) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_LOG_SELECTED_RAILCAR_ID,
      name,
      dynamicTabIndex,
      selectedRailcarId: selectedRailcarId,
    });
  };
};

export const updateSelectedUnitId = (name, dynamicTabIndex, selectedUnitId) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_LOG_SELECTED_UNIT_ID,
      name,
      dynamicTabIndex,
      selectedUnitId: selectedUnitId,
    });
  };
};

export const resetTabLogs = (name, index) => ({
  type: RESET_TAB_LOGS,
  name,
  index,
});

export const setLogsPage = (name, index, pageNb) => ({
  type: SET_LOGS_PAGE,
  name,
  index,
  pageNb,
});

export const setLogsRowsPerPage = (
  name,
  index,
  rowsNb,
  updateDataStore = true
) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: SET_LOGS_ROWS_PER_PAGE,
        name,
        index,
        rowsNb,
      });
      if (updateDataStore) {
        await dataStorePut(
          `${GLOBAL_PREFERENCES}_${name}`,
          update(getGlobalPreferencesFromState(getState()), {
            rowsPerPage: { $set: rowsNb },
          })
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const setCollapsed = (name, collapsed, updateDataStore = true) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: SET_COLLAPSED,
        name,
        payload: collapsed,
      });
      if (updateDataStore) {
        await dataStorePut(
          `${GLOBAL_PREFERENCES}_${name}`,
          update(getGlobalPreferencesFromState(name, getState()), {
            collapsedSections: { $set: collapsed },
          })
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const setDetection = (name, index, detection) => ({
  type: SET_DETECTION,
  name,
  index,
  detection,
});

export const setMainNotes = (name, index, mainNotes) => ({
  type: SET_MAIN_NOTES,
  name,
  index,
  mainNotes,
});
